module.exports = __webpack_public_path__ + "img/slider-shop-image.a659f1e3.png";